import { createApi } from '@reduxjs/toolkit/query/react';

import rtkFetchRequest from '../configs/rtkFetchRequest';

// Define a service using a base URL and expected endpoints
export const paymentsApi = createApi({
  reducerPath: 'payments',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getListPayments: builder.query({
      query: (params = {}) => ({
        method: 'GET',
        endpoint: `/payment-methods`,
        body: params,
      }),
    }),
    getPaymentById: builder.query({
      query: (id) => ({
        method: 'GET',
        endpoint: `/payment-methods/${id}`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetListPaymentsQuery, useGetPaymentByIdQuery } = paymentsApi;
